import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {Router, ActivatedRoute} from '@angular/router';
import {Http, Response, Headers} from '@angular/http';
import {CustomHttp} from '../../../common/customHttp.service';
import {ApiUrl} from '../../../common/apiUrls';
import {FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {ValidationService} from '../../../common/validationservice';
import {MainAppComponent} from '../../../layout/layout.component';
import {PagerService} from '../../../common/pagerService';
import {UserModel, UserRole, ChangePassword} from '../../../common/viewModels/user';
import 'rxjs/add/operator/map'

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {
  reasetPasswordForm: FormGroup;
  private changePassword: ChangePassword = new ChangePassword();
  isResetSubmit: boolean = false;
  isSubmitted: boolean = false;

  constructor(public _router: Router, private _mApp: MainAppComponent, private formBuilder: FormBuilder, private _pageSrvc: PagerService, private _http: CustomHttp,
              private _appUrl: ApiUrl, private  _route: ActivatedRoute, private  _validationService: ValidationService, private _toastrService: ToastrService) {
  }

  ngOnInit() {
    this.reasetPasswordForm = this.formBuilder.group({
      UserId: ['0'],
      'passwords': this.formBuilder.group({
        Password: ['', Validators.compose([Validators.required,Validators.minLength(6), Validators.maxLength(15)])],
        ConfirmPassword: ['', Validators.compose([Validators.required])],
      }, {validator: this._validationService.PasswordMatch,})
    })
  }

  onSubmit() {

    this.isResetSubmit = true;
    if (this.reasetPasswordForm.valid) {
      this._mApp.ShowLoader();
      let resetData=this.reasetPasswordForm.value;
      this.changePassword.Password = this.reasetPasswordForm.value.passwords.Password;
      this.changePassword.NewPassword = this.reasetPasswordForm.value.passwords.ConfirmPassword;
      this.changePassword.ConfirmPassword = this.reasetPasswordForm.value.passwords.ConfirmPassword;
      this.changePassword.UserId = this._route.snapshot.params['id'];

      // this._http.resetPassword(this._appUrl.ChangePassword, this.changePassword)//
      //   .subscribe(
      //     data => {
      //
      //       this._mApp.HideLoader();
      //       this.reasetPasswordForm.reset();
      //       this._toastrService.success('Password updated successfully.', '');
      //       this._router.navigate(['/login']);
      //     },
      //     error => {
      //       this._mApp.HideLoader();
      //       this._toastrService.error(error.json().Result.Message, '');
      //     }
      //   );
      // this._http.resetPassword(this._appUrl.ChangePassword, this.changePassword)
      //   .subscribe(
      //     data => {
      //
      //       this._mApp.HideLoader();
      //       this.reasetPasswordForm.reset();
      //       this._toastrService.success('Password updated successfully.', '');
      //       this._router.navigate(['/login']);
      //     },
      //     error => {
      //       this._mApp.HideLoader();
      //       this._toastrService.error(error.json().Result.Message, '');
      //     }
      //   );
    }

  }
}
